"use client"

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { AuthProvider, useAuth } from "./contexts/AuthContext"
import Login from "./components/Login"
import Register from "./components/Register"
import Dashboard from "./components/Dashboard"
import Subscription from "./components/Subscription"
import Navbar from "./components/Navbar"
import Footer from "./components/Footer"
import Home from "./components/Home"
import ApiPage from "./pages/api"
import EnterprisePage from "./pages/enterprise"
import ChangelogPage from "./pages/changelog"
import HelpPage from "./pages/help"
import DocsPage from "./pages/docs"
import ContactPage from "./pages/contact"
import StatusPage from "./pages/status"
import CommunityPage from "./pages/community"
import FaqPage from "./pages/faq"
import ReportPage from "./pages/report"
import AboutPage from "./pages/about"
import BlogPage from "./pages/blog"
import CareersPage from "./pages/careers"
import PressPage from "./pages/press"
import PartnersPage from "./pages/partners"
import LegalPage from "./pages/legal"
import SecurityPage from "./pages/security"
import TeamPage from "./pages/team"
import ForgotPassword from "./pages/forgot-password"
import VerifyResetCode from "./pages/verify-reset-code"
import ResetPassword from "./pages/reset-password"
import "./App.css"

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-600"></div>
      </div>
    )
  }

  return user ? children : <Navigate to="/login" />
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/subscription"
                element={
                  <ProtectedRoute>
                    <Subscription />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/api" element={<ApiPage />} />
              <Route path="/enterprise" element={<EnterprisePage />} />
              <Route path="/changelog" element={<ChangelogPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/docs" element={<DocsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/status" element={<StatusPage />} />
              <Route path="/community" element={<CommunityPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/report" element={<ReportPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/press" element={<PressPage />} />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="/legal" element={<LegalPage />} />
              <Route path="/security" element={<SecurityPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/verify-reset-code" element={<VerifyResetCode />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App
